
<div class="media mt-0">

   <div class="mr-2 img-profil__photo{{imageSize}}" *ngIf="!image"
        [tooltip]="firstName + ' ' + lastName"
        [innerHTML]="firstName|user2Lettre:lastName"></div>

   <img class="mr-2 img-thumbnail rounded-circle thumb{{imageSize}}" *ngIf="image" src="{{image}}"
        tooltipHtml="{{firstName}} {{lastName}}"
       alt="Image" appImgFallback="assets/img/default-image.png"/>

  <div class="media-body" *ngIf="!onlyPhoto">
    <h6 class="m-0 text-bold mr-1" [ngStyle]="{color: theme === 'white'? '#FFFFFF' : '', 'font-size':'13px'}">
      <div [innerHTML]="firstName"></div><div [innerHTML]="lastName"></div>
    </h6>
    <div class="text-sm text-muted mr-1"  style="display: inline-block;" [tooltip]="toolTipSubTitlePrefix"
         [ngStyle]="{color: theme === 'white'? '#FFFFFF' : ''}" [innerHTML]="subTitlePrefix"></div>
    <div class="text-sm text-muted"  style="display: inline-block;font-size: 11px"
         [ngStyle]="{color: theme === 'white'? '#FFFFFF' : ''}" [innerHTML]="subTitle"></div>
  </div>

</div>

